function formatTable(content) {
  content = content.map(list => {
    const newList = [];

    list.forEach(item => {
      if (item === 'span' && newList.length > 0) {
        newList[newList.length - 1].colspan += 1;
      } else {
        newList.push({
          text: item,
          colspan: 1
        });
      }
    });

    return newList
  });

  return content;
}

export default formatTable;



// WEBPACK FOOTER //
// ./src/helpers/formatTable.js